export interface MipsBlockReason {
  code: string;
  name: string;
  description: string;
}

// Standard list of MIPS submission block reasons defined by Reg-ENT.
export const MIPS_BLOCK_REASONS: MipsBlockReason[] = [
  {
    code: 'PAYMENT_STATUS',
    name: 'Payment Status',
    description: 'Invoice status, outstanding balances.',
  },
  {
    code: 'DATA_AVAILABILITY',
    name: 'Data Availability',
    description: 'Missing or delayed data, data not yet received, incomplete data deliveries.',
  },
  {
    code: 'EHR_CONNECTIVITY',
    name: 'EHR Connectivity & Integration',
    description: 'EHR onboarding, connectivity issues, data extraction, interface or integration status.',
  },
  {
    code: 'REPORTING_EXCEPTIONS',
    name: 'Reporting Exceptions',
    description: 'Special reporting scenarios, practice-specific exceptions, alternate reporting workflows (e.g., provider submitting only three Quality measures).',
  },
];

export function getMipsBlockReasonName(code: string): string {
  return MIPS_BLOCK_REASONS.find((reason) => reason.code === code)?.name ?? code;
}
